import { AtSignIcon, LockIcon, SettingsIcon } from "@chakra-ui/icons";
import {
	Avatar,
	Box,
	Button,
	Flex,
	Heading,
	HStack,
	Menu,
	MenuButton,
	MenuDivider,
	MenuItem,
	MenuList,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Link as RouterLink, useHistory } from "react-router-dom";
import { useAuth } from "../contexts/authContext";
import firebase from "../firebase";
import theme from "../helpers/theme";

export const Navbar = () => {
	const history = useHistory();

	const { currentUser } = useAuth();
	const [pfp, setPfp] = useState();

	useEffect(() => {
		if (currentUser && currentUser.photoURL !== null)
			setPfp(currentUser.photoURL);
		else
			setPfp(
				"https://firebasestorage.googleapis.com/v0/b/kyoi-dev.appspot.com/o/Public%2Fhappyemilia.jpg?alt=media&token=c10eadf2-aafe-4057-83ad-1581824c6685"
			);
	}, [currentUser]);

	return (
		<Box bg="gray.100" px={4}>
			<Flex
				h={20}
				alignItems={"center"}
				justifyContent={"space-between"}
				px={{ base: "5", lg: "10rem", xl: "25rem" }}
			>
				<HStack spacing={8} alignItems={"center"}>
					<RouterLink to="/main">
						<Box
							d="flex"
							alignItems="center"
							justifyContent="center"
							userSelect="none"
						>
							{/* <Avatar src="https://firebasestorage.googleapis.com/v0/b/kyoi-dev.appspot.com/o/Public%2Flogo.jpg?alt=media&token=c9e88d71-b702-4216-9937-24edcb5678db" /> */}
							<Heading
								size="lg"
								bgGradient={`linear(to-r, blue.500, ${theme.colours.accent}.400)`}
								bgClip="text"
							>
								Clubbo
							</Heading>
						</Box>
					</RouterLink>
				</HStack>
				<Flex alignItems={"center"} justifyContent="center">
					<Menu closeOnBlur={true}>
						<MenuButton
							as={Button}
							rounded="full"
							variant="link"
							cursor="pointer"
							d="flex"
							alignItems="center"
							justifyContent="center"
						>
							<Flex
								alignItems="center"
								color={`${theme.colours.accent}.900`}
							>
								<Avatar src={pfp} mr="2" />
								<span>{currentUser.displayName}</span>
							</Flex>
						</MenuButton>
						<MenuList>
							<MenuItem
								d="flex"
								justifyContent="space-between"
								as={RouterLink}
								to="/@me"
							>
								<span>My Profile</span>
								<AtSignIcon mr="2" />
							</MenuItem>
							<MenuItem
								d="flex"
								justifyContent="space-between"
								as={RouterLink}
								to="/@me/settings"
							>
								<span>Settings</span>
								<SettingsIcon mr="2" />
							</MenuItem>
							<MenuDivider />
							<MenuItem
								d="flex"
								justifyContent="space-between"
								onClick={() =>
									firebase
										.auth()
										.signOut()
										.then(() => history.push("login"))
								}
							>
								<span>Log Out</span>
								<LockIcon mr="2" />
							</MenuItem>
						</MenuList>
					</Menu>
				</Flex>
			</Flex>
		</Box>
	);
};
